// extracted by mini-css-extract-plugin
module.exports = {"row":"styles_row__345DV","size-sm":"styles_size-sm__3LpAW","size-lg":"styles_size-lg__emgJt"};